import { render, staticRenderFns } from "./verifiedVehicle.vue?vue&type=template&id=1daf892b&scoped=true"
import script from "./verifiedVehicle.vue?vue&type=script&lang=js"
export * from "./verifiedVehicle.vue?vue&type=script&lang=js"
import style0 from "./verifiedVehicle.vue?vue&type=style&index=0&id=1daf892b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daf892b",
  null
  
)

export default component.exports